// Utils and Constants
import {
  formatText,
  toLocaleString,
} from "../../../common-utils/string-utils/StringUtils";

// Components
import TableHeaders from "../../../components/table/TableHeaders";

//Section Constants
const tableHeaders = [
  {
    title: {
      displayName: "Total Impressions",
      className: "col-2",
    },
  },
  {
    title: {
      displayName: "Total Reach",
      className: "col-2",
    },
  },
  {
    title: {
      displayName: "Frequency",
      className: "col-2",
    },
  },
  {
    title: {
      displayName: "TG Impressions",
      className: "col-2",
    },
  },
  {
    title: {
      displayName: "TG Reach",
      className: "col-2",
    },
  },
];

// Segment Ots Splitted Table
export default function SegmentOtsSplittedTable({
  segmentOtsAndReachInfo = {},
}) {
  const { tgReach, totalReach, tgImp, totalImpressions, frequency } =
    segmentOtsAndReachInfo;

  return (
    <div className="table-responsive mt-4">
      <h4>Impressions</h4>

      <table className="table table-media">
        {/* Table header */}
        <TableHeaders tableHeaders={tableHeaders} headerClass={"thead"} />

        <tbody>
          <tr>
            <td>{formatText(toLocaleString(totalImpressions))}</td>
            <td>{formatText(toLocaleString(totalReach))}</td>
            <td>{formatText(toLocaleString(frequency))}</td>
            <td>{formatText(toLocaleString(tgImp))}</td>
            <td>{formatText(toLocaleString(tgReach))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
